@use '../../../../../scss/settings/colors';
@use '../../../../../scss/settings/breakpoints';

.rightSection {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  background: colors.$base-white;
  border-radius: 8px;
}

.aiSummaryHeader {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
}

.aiSummaryTitle {
  font-family: 'SemiBold Inter', sans-serif !important;
  font-size: 16px;
  color: colors.$dark-blue;
}

.headerActions {
  display: flex;
  //gap: 8px;
  align-items: center;

  .actionButton {
    //padding: 1px;
    flex-shrink: 0;
    color: colors.$gray-variant-16;

    svg {
      width: 20px;
      height: 20px;
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.04);
    }
  }
}

.aiSummaryContent {
  position: relative;
  overflow: auto;
  display: flex;
  flex-direction: column;
  padding: 16px;
  font-family: 'Regular Inter', sans-serif;
  font-size: 14px;

  @media #{breakpoints.$desktop-lg}{
    height: 630px;
  }

  table {
    margin-bottom: 10px;
    border-collapse: collapse;

    td, th {
      padding: 8px;
      font-size: 14px;
      border: 1px solid rgba(0, 0, 0, 0.26);
    }
  }
}


.tableContainer {
  flex: 1;
  max-height: none;
  height: 100%;
  overflow-y: auto;
  box-shadow: none;
  border: 1px solid colors.$border-grey;
  border-radius: 8px;
}

.summaryTable {
  border-collapse: collapse;
  table-layout: fixed;

  tr {
    height: 48px;
  }
}

.tableHeader {
  background-color: colors.$light-grey;
  font-weight: 600;
  padding: 14px 16px;
  font-size: 14px;
}

.keyCell {
  width: 35%;
  font-weight: 500;
  background-color: colors.$light-grey;
  padding: 14px 16px;
  vertical-align: top;
}

.tableCell {
  padding: 14px 16px;
  font-size: 14px;
  line-height: 1.6;
}

.empty_message {
  max-width: 228px;
  margin: auto;
  font-family: "Light Inter", sans-serif;
  font-style: italic;
  font-size: 0.875rem;
  line-height: 1.3125rem;
  text-align: center;
  color: colors.$dark-blue;
}

.empty_state_message {
  font-family: 'SemiBold Inter', sans-serif;
  text-align: center;
  font-size: 16px;
  color: colors.$dark-blue;
}